export function initDadosUsuarioForm() {
    return {type: "INIT_DADOS_USUARIO_FORM"}
}

export function saveUserData(data){
    return {type: "SAVE_USER_DATA", payload: data}
}
